import { Entity } from '@backstage/catalog-model';

/**
 * Annotation that stores the original GitHub repository name for edge-case
 * repositories whose name had to be sanitized to become a valid Backstage
 * entity name during ingestion (e.g. `.github` -> `github`).
 *
 * It is only present on those edge-case repositories — normal repositories,
 * whose entity name already equals their real repository name, do not carry it.
 *
 * Writer: `GithubRepositoryOwnershipProvider` in
 * `@internal/plugin-catalog-backend-module-entity-ingestion`.
 */
export const ORIGINAL_REPOSITORY_NAME_ANNOTATION =
  'tomtom.com/original-repository-name';

/**
 * Resolve the real GitHub repository name for a `Repository` entity.
 *
 * Returns the original repository name from the
 * `tomtom.com/original-repository-name` annotation when present (edge-case
 * repositories whose name was sanitized during ingestion), otherwise falls back
 * to `metadata.name`. This means normal repositories behave exactly as before —
 * only edge cases resolve via the annotation.
 *
 * Use this instead of reading `entity.metadata.name` directly whenever a
 * repository identifier is sent to Watchtower engineering-insights or
 * scorecards (e.g. as `repository_names`).
 */
export function getRepositoryName(entity: Entity): string {
  return (
    entity.metadata.annotations?.[ORIGINAL_REPOSITORY_NAME_ANNOTATION] ??
    entity.metadata.name
  );
}
